<template>
  <div class="pageContainer">
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card loginCard">
            <img src="../../../assets/images/logo.png" style="width: 35%;margin:auto; margin-top:20px;"/>

            <div>
              <h4 style="display: inline-block; margin-right: 20%">
                استعادة كلمة المرور
              </h4>
              <a
                href="/login"
                class="text-info"
                style="margin-right: 18%; font-size: 30px"
                ><i class="fas fa-arrow-circle-left"></i
              ></a>
            </div>
            <div class="card-body">
              <form @submit.prevent="sendPasswordResetEmail">
                <div class="form-group">
                  <label for="email">البريد الإلكتروني</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="email"
                  />
                  <div class="text-danger">{{ errors.email }}</div>
                </div>
                <div class="form-group">
                  <label for="code">الكود</label>
                  <input type="text" class="form-control" id="code" v-model="code" />
                  <div class="text-danger">{{ errors.code }}</div>
                </div>
                <div class="form-group">
                  <label for="password">كلمة المرور الجديدة</label>
                  <input type="password" class="form-control" id="password" v-model="password" />
                  <div class="text-danger">{{ errors.password }}</div>
                </div>
                <div class="form-group">
                  <label for="confirmPassword">تأكيد كلمة المرور الجديدة</label>
                  <input type="password" class="form-control" id="confirmPassword" v-model="confirmPassword" />
                  <div class="text-danger">{{ errors.confirmPassword }}</div>
                </div>
                <button type="submit" class="btn btn-primary">حفظ</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";
import * as yup from "yup";

const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email("الرجاء إدخال بريد إلكتروني صحيح")
    .required("يرجى إدخال البريد الإلكتروني"),
  password: yup.string().required("يرجى إدخال كلمة المرور"),
  confirmPassword: yup.string().required("يرجى إدخال كلمة المرور"),
  code: yup.string().required("يرجى إدخال الكود"),
});

export default {
  data() {
    return {
      code: "",
      password: "",
      confirmPassword: "",
      email: "",
      errors: {},
    };
  },
  methods: {
    sendPasswordResetEmail() {
      const { email } = this;
      const { password } = this;
      const { code } = this;
      const { confirmPassword } = this;
      forgotPasswordSchema
        .validate({ email, password, code, confirmPassword }, { abortEarly: false })
        .then(() => {
          Axios
            .post("/forgetpassword", {
              email: email,
              code: code,
              password: password,
              confirmPassword: confirmPassword
            })
            .then((response) => {
              Swal.fire({
                icon: "success",
                title: "تم تجديد كلمة المرور!",
                confirmButtonText: "حسنًا",
              }).then(() => {
                this.$router.push("/login");
              });
            })
            .catch((errors) => {
              // console.log(errors.response.data.message);
              const error_message = "";
              if (errors.response.data.message == "User of that email not found"){
                this.error_message="لا يوجد مستخدم مسجل بهذا البريد الإلكتروني"
              }
              else if(errors.response.data.message == "Password not matched!"){
                this.error_message="كلمة المرور غير مطابقة لتأكيد كلمة المرور"
              }
              else{
                this.error_message="هذا الكود غير صحيح"
              }
              Swal.fire({
                icon: "error",
                title: this.error_message,
                confirmButtonText: "حسنًا",
              })
          });
        })
        .catch((errors) => {
          // Yup validation errors
          const errorMessages = {};
          errors.inner.forEach((error) => {
            errorMessages[error.path] = error.message;
          });
          this.errors = errorMessages;
        });
    },
  },
};
</script>

<style></style>
